var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-color-picker',{attrs:{"value":_vm.value,"show-alpha":true},on:{"active-change":function($event){return _vm.$emit('input',$event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }